import { Box, Divider, Group, Stack } from "@mantine/core"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { ThreadStatusTag } from "./SuperAdminThreads"
import { SuperAdminThreadMessages } from "./messages/SuperAdminThreadMessages"
import { SuperAdminThreadPreview } from "src/components/superadmin/threads/SuperAdminThreadPreview"

export function SuperAdminThreadOverlay() {

    const { currentItem } = useAppState(state => state.threads)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.subject}`}
                    badge={<ThreadStatusTag status={currentItem?.thread_status!} />}
                    renderAction={
                        <Group gap="sm">

                        </Group>
                    }
                    preview={<SuperAdminThreadPreview />}
                />
            }
        >

            <Stack gap="sm">
                <Divider
                    my="0"
                    variant="dashed"
                    labelPosition="left"
                    label={<Box ml={5}>Messages</Box>}
                />
                <SuperAdminThreadMessages />
            </Stack>

        </DrawerPageLayout>
    )

}